import React from 'react';

import { Box, Popover, Text } from 'core/components';
import DeviceLink from 'app/components/links/DeviceLink';
import FilteredDevicesLink from 'app/components/links/FilteredDevicesLink';

export default function PlanDevicesPopover({ planDevices, showViewAllLink = true }) {
  function getDeviceLinkText(device) {
    return device.device_status === 'D' ? `${device.device_name} (Archived)` : device.device_name;
  }

  function popoverContent() {
    return (
      <Box p={1} maxHeight={500} overflow="auto" minWidth={180}>
        <Text as="div" mb={1} fontWeight="bold">
          Devices in this plan:
        </Text>

        {showViewAllLink && (
          <Box key="view-all-link" mb="4px">
            <FilteredDevicesLink filters={{ plan: [`${planDevices[0].plan_id}`], isArchived: false }}>
              <Text>View All</Text>
            </FilteredDevicesLink>
          </Box>
        )}

        {planDevices.map((device) => (
          <Box key={device.id} mb="4px">
            <DeviceLink name={device.device_name}>
              <Text>{getDeviceLinkText(device)}</Text>
            </DeviceLink>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    planDevices.length > 0 && (
      <Popover minimal={false} targetTagName="span" position="left-top" content={popoverContent()}>
        <Text role="link" as="a" color="primary">
          (Show)
        </Text>
      </Popover>
    )
  );
}
